import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import i18n from 'i18n';

import {getStatics} from 'config/app';

import API from '../lib/api';
import TeamMemberList from './team-member-list';

import {logoVoxfeedThumbnailBlackImg} from 'assets/images';
import { getDefaultTitle } from 'config/app';

const SettingsAbout = createClass({
  getInitialState() {
    return {teamMembers: []};
  },

  componentDidMount() {
    this.loadMembersFromServer();
  },

  loadMembersFromServer() {
    API.teamMembers((err, data) => {
      if (err) console.log(err);
      else {
        this.setState({ teamMembers: data });
      }
    });
  },

  render() {
    const currentYear = new Date().getFullYear();
    const {about} = getStatics();
    const companyName = getDefaultTitle()

    return (
      <div className='vf-wrapper vf-settings-about padding-top-2x'>
        <div className='vf-row'>
          <div className='col-xs-12'>
            <h3>{i18n.get('INF_SETTINGS_ABOUT_ABOUT')}</h3>
          </div>
        </div>
        <div className='vf-row padding-top-2x'>
          <div className='col-xs-12 col-sm-5 col-lg-6'>
            <h2 className='voxfeed'><img className='thumb' src={logoVoxfeedThumbnailBlackImg} /> VoxFeed <small>v3.2</small></h2>

            {i18n.getHTML('INF_SETTINGS_ABOUT_COPYRIGHT', {currentYear, companyName})}
            {i18n.getHTML('INF_SETTINGS_ABOUT_ADDRESS')}



            <p>
              <a href={about.help} target='_blank'>{i18n.get('INF_SETTINGS_ABOUT_HELP')}</a>
              {' | '}
              <a href={about.blog} target='_blank'>{i18n.get('INF_SETTINGS_ABOUT_BLOG')}</a>
              {' | '}
              <a href={about.terms} target='_blank'>{i18n.get('INF_SETTINGS_ABOUT_TOS')}</a>
              <br />
              <a href='mailto:contacto@voxfeed.com'>contacto@voxfeed.com</a>
              {' | '}
              <strong>01 (33) 2003 0374</strong>
            </p>
          </div>
          <div className='col-xs-12 col-sm-7 col-lg-6 team'>
            <h2>{i18n.get('INF_SETTINGS_TEAM_VOXFEED',{companyName})}</h2>
            <div>
              <TeamMemberList members={this.state.teamMembers} />
            </div>
          </div>
        </div>
      </div>
    );
  }

});

module.exports = SettingsAbout;
